const earthChartOpt = {
  styleId:1,
  pluginName: ["baseEarthPlugin"]
}
export { earthChartOpt }
